import { forwardRef } from "react";
import Head from "next/head";
import { cn } from "ui";

interface LayoutProps {
  metaTitle: string;
  children: React.ReactNode;
  className?: string;
}

const Layout = forwardRef<HTMLDivElement, LayoutProps>(
  ({ children, metaTitle, className }, ref) => {
    return (
      <>
        <Head>
          <title>
            {metaTitle || "Dashboard"} - {process.env.NEXT_PUBLIC_APP_TITLE}
          </title>
          <meta name="description" content="Generated by MoneyHash" />
          <link rel="icon" href="/favicon.ico" />
        </Head>

        <div
          ref={ref}
          className="h-full w-full flex-1 overflow-y-auto overflow-x-hidden focus:outline-none"
        >
          <main
            className={cn(
              "relative mx-auto max-w-screen-2xl px-8 py-6",
              className
            )}
          >
            {children}
          </main>
        </div>
      </>
    );
  }
);
Layout.displayName = "Layout";

export default Layout;
